import { render, staticRenderFns } from "./serviceEdit.vue?vue&type=template&id=87610e42"
import script from "./serviceEdit.vue?vue&type=script&lang=js"
export * from "./serviceEdit.vue?vue&type=script&lang=js"
import style0 from "./serviceEdit.vue?vue&type=style&index=0&id=87610e42&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports